import { Recipient } from "react-migration/domains/sites/typings";
import { useTranslation } from "react-migration/lib";

import { InfoTooltip } from "./InfoTooltip";

type RecipientCell = Omit<Recipient, "geometry">;

type DeprecatedRecipientColumnProps = {
  recipient: RecipientCell;
  colKey: keyof RecipientCell;
};

export const DeprecatedRecipientCell = ({ recipient, colKey }: DeprecatedRecipientColumnProps) => {
  const { t } = useTranslation();

  if (recipient.hasOwnProperty("isGranted") && !recipient.isGranted) {
    return (
      <div className="atlas-flex atlas-flex-col">
        <span className="atlas-flex">{recipient[colKey]}</span>
        <InfoTooltip
          content={t("sites.letters.recipients.unavailable_for_letter_sending")}
          tooltipContent={t("sites.letters.recipients.owner_details_unavailable")}
          dataTestId="unavailable-for-letter-sending"
        />
      </div>
    );
  } else if (recipient.hasOwnProperty("isValid") && !recipient.isValid) {
    return (
      <div className="atlas-flex atlas-flex-col">
        <span className="atlas-flex">{recipient[colKey]}</span>
        <InfoTooltip
          content={t("sites.letters.recipients.address_incomplete")}
          tooltipContent={t("sites.letters.recipients.incomplete")}
          dataTestId="invalid-recipient"
        />
      </div>
    );
  } else {
    return recipient[colKey];
  }
};
